"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagsGa = void 0;
var react_1 = require("react");
var slugify_1 = require("../slugify");
var TagsGa = function (_a) {
    var children = _a.children, category = _a.category, action = _a.action, label = _a.label, eventType = _a.eventType;
    var builtCategory = category === null || category === void 0 ? void 0 : category.map(slugify_1.slugify).join(':');
    var builtAction = action === null || action === void 0 ? void 0 : action.map(slugify_1.slugify).join(':');
    var builtLabel = label === null || label === void 0 ? void 0 : label.map(slugify_1.slugify).join(':');
    var builtEventType = eventType
        ? {
            'data-gtm-event-type': eventType,
        }
        : null;
    return (0, react_1.cloneElement)(children, __assign(__assign(__assign({}, children.props), { 'data-gtm-event-category': builtCategory, 'data-gtm-event-action': builtAction, 'data-gtm-event-label': builtLabel }), builtEventType));
};
exports.TagsGa = TagsGa;
